var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error"},[_vm._m(0),_c('p',[_vm._v("You can return to the home page "),_c('router-link',{attrs:{"to":{ name: 'Instruction'}}},[_vm._v("here")]),_vm._v(".")],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_c('b',[_vm._v("Your account data is currently unavailable. "),_c('br'),_vm._v("Please contact your INFUSE Client Success Representative for further assistance.")])])
}]

export { render, staticRenderFns }